import { useEffect } from 'react';

const HREF = '/stylesheets/student_text_combined_style_sheet.css';

// The pour panes render student text under the same class stack as the section edit page, whose
// typography lives in a stylesheet the SPA layout does not load. Linked once, on first use.
const useStudentTextStylesheet = () => {
  useEffect(() => {
    if (document.querySelector(`link[href="${HREF}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = HREF;
    document.head.appendChild(link);
  }, []);
};

export default useStudentTextStylesheet;
